// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"40b08bad","90":"f2c7d36d","173":"22f35200","236":"721658dd","513":"55aae100","703":"99ad32a4"}[chunkId] + ".chunk.js";
};